module.exports = __webpack_public_path__ + "img/hotel_ghasr.220ea389.svg";